import { gspx } from '@rsos/capstone';

export const handleCopy = ({
  value,
  name,
  irpVersion,
  payloadID,
  requestID,
  onStart,
  onEnd,
  portalType,
}) => {
  navigator.clipboard.writeText(value);
  gspx.trackCustomEvent('Data Location', {
    irpVersion,
    name: `Copy '${name}'`,
    Category: 'Location Card Copy coordinates',
    'Launched date': new Date(),
    payloadID,
    requestID,
    portalType,
  });
  onStart();
  setTimeout(() => {
    onEnd();
  }, 3000);
};
